export const documents_locale = {
    PDF_GENERAL_ERROR: "Something happend while loading the document.",
    PDF_VIEWER_TITLE: "Document viewer",
    CONTAINERS: "Containers"
};